/* models/icon.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    var _a;
    const tabler_icon_1 = require("@bokehjs/models/ui/icons/tabler_icon");
    const svg_icon_1 = require("@bokehjs/models/ui/icons/svg_icon");
    const control_1 = require("@bokehjs/models/widgets/control");
    const build_views_1 = require("@bokehjs/core/build_views");
    class ToggleIconView extends control_1.ControlView {
        *controls() { }
        remove() {
            var _b;
            (_b = this.icon_view) === null || _b === void 0 ? void 0 : _b.remove();
            super.remove();
        }
        async lazy_initialize() {
            await super.lazy_initialize();
            this.was_svg_icon = this.is_svg_icon(this.model.icon);
            this.icon_view = await this.build_icon_model(this.model.icon, this.was_svg_icon);
        }
        *children() {
            yield* super.children();
            yield this.icon_view;
        }
        is_svg_icon(icon) {
            return icon.trim().startsWith('<svg');
        }
        toggle_value() {
            if (this.model.disabled) {
                return;
            }
            this.model.value = !this.model.value;
            this.update_icon();
        }
        connect_signals() {
            super.connect_signals();
            const { icon, active_icon, value, disabled } = this.model.properties;
            this.on_change([active_icon, icon, value], () => this.update_icon());
            this.on_change(disabled, () => this.update_cursor());
        }
        render() {
            super.render();
            this.icon_view.render();
            this.update_icon();
            this.update_cursor();
            this.shadow_el.appendChild(this.icon_view.el);
        }
        update_cursor() {
            this.icon_view.el.style.cursor = this.model.disabled ? 'not-allowed' : 'pointer';
        }
        async build_icon_model(icon, is_svg_icon) {
            const size = this.calculate_size();
            let icon_model;
            if (is_svg_icon) {
                icon_model = new svg_icon_1.SVGIcon({ svg: icon, size: size });
            }
            else {
                icon_model = new tabler_icon_1.TablerIcon({ icon_name: icon, size: size });
            }
            const icon_view = await (0, build_views_1.build_view)(icon_model, { parent: this });
            icon_view.el.addEventListener('click', () => this.toggle_value());
            return icon_view;
        }
        async update_icon() {
            const icon = this.model.value ? this.get_active_icon() : this.model.icon;
            const is_svg_icon = this.is_svg_icon(icon);
            if (this.was_svg_icon !== is_svg_icon) {
                // If the icon type has changed, we need to rebuild the icon view
                // and invalidate the old one.
                const icon_view = await this.build_icon_model(icon, is_svg_icon);
                icon_view.render();
                this.icon_view.remove();
                this.icon_view = icon_view;
                this.was_svg_icon = is_svg_icon;
                this.update_cursor();
                this.shadow_el.appendChild(this.icon_view.el);
            }
            else if (is_svg_icon) {
                this.icon_view.model.svg = icon;
            }
            else {
                this.icon_view.model.icon_name = icon;
            }
            this.icon_view.el.style.lineHeight = '0';
        }
        get_active_icon() {
            return this.model.active_icon !== '' ? this.model.active_icon : `${this.model.icon}-filled`;
        }
        calculate_size() {
            var _b, _c;
            if (this.model.size !== null)
                return this.model.size;
            const maxWidth = (_b = this.model.width) !== null && _b !== void 0 ? _b : 15;
            const maxHeight = (_c = this.model.height) !== null && _c !== void 0 ? _c : 15;
            const size = Math.max(maxWidth, maxHeight);
            return `${size}px`;
        }
    }
    exports.ToggleIconView = ToggleIconView;
    ToggleIconView.__name__ = "ToggleIconView";
    class ToggleIcon extends control_1.Control {
        constructor(attrs) {
            super(attrs);
        }
    }
    exports.ToggleIcon = ToggleIcon;
    _a = ToggleIcon;
    ToggleIcon.__name__ = "ToggleIcon";
    ToggleIcon.__module__ = "panel.models.icon";
    (() => {
        _a.prototype.default_view = ToggleIconView;
        _a.define(({ Boolean, Nullable, String }) => ({
            active_icon: [String, ""],
            icon: [String, "heart"],
            size: [Nullable(String), null],
            value: [Boolean, false],
        }));
    })();
}
